import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CONSENT_APP_CONFIG, ConsentService } from 'analytics';
import { ConsentTextsService } from './consent-texts.service';

/**
 * Persistent "Cookie settings" link (contract V2 §1) for footers. Renders nothing
 * in apps without the consent banner. While it is on screen the overlay's own
 * floating link is hidden (see ConsentService.footerLinks). Its label follows the
 * banner's language rule (ConsentTextsService), so it renders once the config is in.
 */
@Component({
  selector: 'app-cookie-settings-link',
  standalone: true,
  template: `
    @if (enabled && texts.ready()) {
      <a href="#" class="cookie-settings-link" [attr.lang]="texts.lang()" [attr.dir]="texts.dir()"
         (click)="open($event)">{{ texts.t('consent.footer_link') }}</a>
    }
  `,
  styles: [`:host { display: contents; } .cookie-settings-link { cursor: pointer; }`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieSettingsLinkComponent implements OnInit, OnDestroy {
  private consent = inject(ConsentService);
  /** Same language rule as the banner (reviewed languages only, else the master). */
  protected readonly texts = inject(ConsentTextsService);
  protected readonly enabled = inject(CONSENT_APP_CONFIG, { optional: true })?.enabled === true;
  private unregister: (() => void) | null = null;

  ngOnInit(): void {
    if (this.enabled) this.unregister = this.consent.registerFooterLink();
  }

  ngOnDestroy(): void {
    this.unregister?.();
  }

  protected open(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.consent.openPreferences();
  }
}
